module.exports = __webpack_public_path__ + "static/media/top-up-sticker.b8b32aa2.png";